import { makeStyles } from '@material-ui/core/styles';
import { isiOS } from '../../../utils/utility';

const makeStyle = makeStyles(theme => ({
    confirmSiteContainer:{
        overflowY: "auto",
        overflowX: "hidden",
        marginTop: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
        height: isiOS() ? 'calc(91vh - 64px - env(safe-area-inset-top))' : 'calc(91vh - 64px)',
        width: "100% !important",
        display: 'flex',
        flex:'1 1 auto',
        flexDirection: 'column',
        backgroundColor: `${theme.palette.primary.background} !important`,
        padding: '16px'
    },
    confirmSiteWrapper:{
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
    },
    confirmSiteHeading:{
        fontSize: '12px',
        fontWeight: '700',
        lineHeight: '16px',
        letterSpacing: '0.02em',
        textAlign: 'left',
        textTransform: 'uppercase',
        fontFamily: 'T-star',
        color: theme.palette.secondary.subHeading,
    },
    confirmSiteSubHeading:{
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '16px',
        textAlign: 'start',
        padding: '24px 0px 16px 0px',
        color: '#545456',
    },
    siteAddressCard:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flexStart',
        padding: '16px',
        gap: '10px',
        borderRadius: '8px',
        background: `${theme.palette.tertiary.sheetContainer} !important`,
        boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.10)',
    },
    siteName:{
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: 'normal',
        wordBreak: "break-word",
        color: theme.palette.primary.heading,
    },
    siteAddressDetails:{
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '16px',
        wordBreak: "break-word",
    },
    addressLine: {
        marginBottom: '4px',
        color: theme.palette.primary.mainHeading,
    },
    buttonContainer:{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginTop: '16px',
        marginBottom: '16px'
    },
    newSiteButton:{
        color: `${theme.palette.tertiary.provisionEnableButton} !important`,
        display: 'flex',
        padding: '12px',
        justifyContent: 'center',
        textTransform:'none',
        alignItems: 'center',
        width:'100%',
        borderRadius: '8px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton} !important`,
        backgroundColor: `${theme.palette.primary.background} !important`,
    },
    inSiteButton:{
        display: "flex",
        flexDirection: "row",
        gap: "5px"
    },
    continueButton:{
        background: `${theme.palette.tertiary.provisionEnableButton} !important`,
        color: '#fff !important',
        textAlign:'center',
        width:'100%',
        padding:'12px',
        textTransform:'none',
        borderRadius: '8px',
        fontSize: '16px',
    },
}))

export { makeStyle }